import styled from 'styled-components';
import { colors, LayoutColors } from '@src/core/theme';
import { BodySmallMedium } from '@src/fonts/typography/Typography';
import { device } from '@src/common/breakpoints';

export const ForeignAlertContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 8px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 8px;

  border-radius: 4px;
  border-left: 4px solid ${LayoutColors.justBlue};
  background: ${colors.blue[100]};

  ${device.mediumTablet} {
    padding: 12px;
    align-self: stretch;
  }
`;

export const ForeignAlertBadge = styled.span`
  display: flex;
  padding: 4px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;

  border-radius: 8px;
  background: ${LayoutColors.justBlue};

  color: ${colors.blue[100]};
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-transform: uppercase;
`;

export const ForeignAlertTitle = styled.h4`
  color: ${LayoutColors.justBlue};
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const ForeignAlertDescription = styled.p`
  ${BodySmallMedium};
  line-height: normal;
  color: ${LayoutColors.justBlue};
`;
